import React, { useEffect, useRef, useState } from "react";
import {
  DashboardCompanyList,
  siteDashboardDetails,
  siteDashboardList,
  superDashboard,
} from "../../redux/api/dummyJson";
import { useNavigate } from "react-router-dom";
import { get } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import VideocamIcon from "@mui/icons-material/Videocam";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeWorkIcon from "@mui/icons-material/HomeWork";

const SuperAdminDashboard = () => {
  const navigate = useNavigate();
  const [companyList, setCompanyList] = useState(DashboardCompanyList);
  const [dashboardList, setDashboardList] = useState({});

  const companyRef = useRef();
  const siteRef = useRef();
  const detailsRef = useRef();

  const [show, setShow] = useState({
    company: false,
    site: false,
    siteDetails: false,
  });

  const [name, setName] = useState({
    company: "",
    site: "",
  });

  useEffect(() => {
    if (show.company && companyRef.current) {
      companyRef.current.focus();
    }
  }, [show.company]);

  useEffect(() => {
    if (show.site && siteRef.current) {
      siteRef.current.focus();
    }
  }, [show.site]);

  useEffect(() => {
    if (show.siteDetails && detailsRef.current) {
      detailsRef.current.focus();
    }
  }, [show.siteDetails]);

  const handleNavigate = (id) => {
    switch (id) {
      case 1:
        navigate("/admin");
        break;
      case 2:
        setShow((prev) => ({ ...prev, company: true }));
        break;
      case 3:
        setShow((prev) => ({ ...prev, site: true }));
        break;
      case 4:
        setShow((prev) => ({ ...prev, siteDetails: true }));
        break;
      default:
        break;
    }
  };

  const getDashboard = () => {
    get(URL.ADMIN_DASHBOARD)
      .then((res) => {
        if (res?.status == "success") {
          setDashboardList(res?.dashboard_datas);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getDashboard();
  }, []);

  return (
    <div className="dashRightView ">
      <div className="d-flex flex-row flex-wrap gap-5 mt-3 pointer">
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              No of Admin
            </h4>
            <PeopleIcon color="primary" fontSize="large" />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.company_admin_count}
          </h2>
        </div>
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              No of Company
            </h4>
            <BusinessIcon color="secondary" fontSize="large" />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.company_count}
          </h2>
        </div>
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              No of Camera Devices
            </h4>
            <VideocamIcon style={{ color: "teal" }} fontSize="large" />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.camera_count}
          </h2>
        </div>
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              No of New Alerts
            </h4>
            <NotificationsActiveIcon
              style={{ color: "orange" }}
              fontSize="large"
            />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.new_alert_count}
          </h2>
        </div>
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              No of Allocated Alerts
            </h4>
            <AssignmentTurnedInIcon
              style={{ color: "blueviolet" }}
              fontSize="large"
            />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.allocated_alert_count}
          </h2>
        </div>
        <div className=" my-3 content-dashboard">
          <div className="d-flex ac-jb gap-4">
            <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
              No of Closed Alerts
            </h4>
            <DoneAllIcon style={{ color: "green" }} fontSize="large" />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.closed_alert_count}
          </h2>
        </div>
      </div>

      {show.company && (
        <>
          <hr className="border-t-2 border-gray-400 my-5" />
          <div className="d-flex ac-je">
            <button
              className="submit-btn"
              style={{ minWidth: "8%" }}
              onClick={() => setShow(false)}
            >
              Close
            </button>
          </div>
          <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
            Companies List
          </h4>
          <div className="d-flex flex-row flex-wrap gap-5 mt-3 pointer">
            {companyList.map((item) => {
              return (
                <div
                  className=" my-3 content-dashboard"
                  key={item.id}
                  ref={companyRef}
                  tabIndex={-1}
                  onClick={() => {
                    handleNavigate(3);
                    setName((prev) => ({ ...prev, company: item.name }));
                  }}
                >
                  <div className="d-flex ac-jb gap-4 p-4">
                    <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
                      {item.name}
                    </h4>
                    {item.icon}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {show.site && (
        <>
          <hr className="border-t-2 border-gray-400 my-5" />
          <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
            {`${name.company} (Sities List)`}
          </h4>
          <div className="d-flex flex-row flex-wrap gap-5 mt-3 pointer">
            {siteDashboardList.map((item) => {
              return (
                <div
                  className=" my-3 content-dashboard"
                  key={item.id}
                  ref={siteRef}
                  tabIndex={-1}
                  onClick={() => {
                    handleNavigate(4);
                    setName((prev) => ({ ...prev, site: item.name }));
                  }}
                >
                  <div className="d-flex ac-jb gap-4 p-4">
                    <h4 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 gray ">
                      {item.name}
                    </h4>
                    {item.icon}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {show.siteDetails && (
        <>
          <hr className="border-t-2 border-gray-400 my-5" />
          <h4
            className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 "
            tabIndex={1}
            ref={detailsRef}
          >
            {`${name.site} (Site Details)`}
          </h4>
          <div className="d-flex flex-row flex-wrap gap-5 mt-3">
            {siteDashboardDetails.map((item) => (
              <div
                className=" my-3 content-dashboard  p-3 rounded-3"
                key={item.id}
              >
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="f3 fw-bold primary">{item.name}</h5>
                  {item.icon}
                </div>

                <div className="d-flex justify-content-between py-1">
                  <span className="fw-semibold text-muted">Admins</span>
                  <span className="fw-bold">{item.adminCount}</span>
                </div>

                <div className="d-flex justify-content-between py-1">
                  <span className="fw-semibold text-muted">Group 1</span>
                  <span className="fw-bold">{item.groups.group1}</span>
                </div>
                <div className="d-flex justify-content-between py-1">
                  <span className="fw-semibold text-muted">Group 2</span>
                  <span className="fw-bold">{item.groups.group2}</span>
                </div>
                <div className="d-flex justify-content-between py-1">
                  <span className="fw-semibold text-muted">Group 3</span>
                  <span className="fw-bold">{item.groups.group3}</span>
                </div>

                <div className="d-flex justify-content-between py-1">
                  <span className="fw-semibold text-muted">Devices</span>
                  <span className="fw-bold">{item.devices}</span>
                </div>

                <div className="mt-3">
                  <div className="d-flex justify-content-between py-1">
                    <p className="fw-bold new">New Alerts</p>
                    <p className="fw-bold ">{item.newAlerts}</p>
                  </div>
                  <div className="d-flex justify-content-between py-1">
                    <p className="text-info fw-bold allocated">
                      Allocated Alerts
                    </p>
                    <p className="fw-bold ">{item.allocatedAlerts}</p>
                  </div>
                  <div className="d-flex justify-content-between py-1">
                    <p className="text-success fw-bold closed">Closed Alerts</p>
                    <p className="fw-bold">{item.closedAlerts}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SuperAdminDashboard;
